/**
 * Server Scalar extensions.
 *
 * Applied on OpenAPI `servers` entries or document-level server selection state.
 */
export { XScalarSelectedServer } from './x-scalar-selected-server.js';
